//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../../../../axios/axios.js'
import BrigadeCardCheckbox from './BrigadeCardCheckbox.vue'
import BrigadeCardCheckboxWithForever from './BrigadeCardCheckboxWithForever.vue'
import BrigadeAutoAssign from './BrigadeAutoAssign.vue'
import BrigadeActiveRequestsTab from './BrigadeActiveRequestsTab.vue'
import { brigadeEditor, getObjectsIds } from './BrigadeEditor.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    BrigadeCardCheckbox,
    BrigadeCardCheckboxWithForever,
    BrigadeForkliftTruckField: () => import('../../../../../forms/Brigade/BrigadeForkliftTruck/BrigadeForkliftTruckField.vue'),
    BrigadeAutoAssign,
    BrigadeActiveRequestsTab
  },
  mixins: [brigadeEditor],
  props: {
    brigadeId: {
      type: Number,
      default: null
    },
    brigadierId: {
      type: Number,
      default: null
    },
    date: {
      type: Date,
      default () {
        return null
      }
    },
    onlyEditEmployees: {
      type: Boolean,
      default: false
    },
    showNotificationsTab: {
      type: Boolean,
      default: false
    },
    showActiveRequestsTab: {
      type: Boolean,
      default: false
    },
    warnings: {
      type: Array,
      default () {
        return []
      }
    },
    initialTab: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      selectedTab: null,
      tabs: [
        'generalInfo',
        'autoAssign'
      ],

      initialEmployees: [],
      employeesIds: [],
      brigadeInitial: null,
      brigade: {},
      brigadeFromServer: {},
      brigadiers: [],
      regions: [],
      brigadeWorkAreas: [],
      employeesDataForFixed: [],
      loading: false
    }
  },
  computed: {
    isWorkAreasSuitable: function () {
      if (this.brigadeWorkAreas.length === 0) {
        return true
      }

      if (!this.brigade.brigadier) {
        return true
      }

      if (this.brigade.brigadier && this.brigade.brigadier.workAreas && this.brigade.brigadier.workAreas.length) {
        const brigadierWorkAreasNames = this.brigade.brigadier.workAreas
        if (this.brigadeWorkAreas.find(workArea => brigadierWorkAreasNames.includes(workArea.name))) {
          return true
        }
      }

      return false
    },
    autoAssignOnlyWithForkliftTruckLocal: {
      get: function () {
        return this.brigade.autoAssignOnlyWithForkliftTruck
      },
      set: function (value) {
        this.brigade.autoAssignOnlyWithForkliftTruck = value
      }
    },
    brigadiersOptions: function () {
      if (!this.onlyEditEmployees) {
        return this.brigadiers
      } else {
        return this.initialEmployees
          .filter(employee => this.employeesIds && this.employeesIds.includes(employee.id))
          .map(employee => {
            return {
              ...employee,
              disable: !employee.roles || !employee.roles.brigadier
            }
          })
      }
    },
    queueAndActiveRequests: function () {
      return (this.brigade.activeRequests || []).concat(this.brigade.queueRequests || [])
    },
    ...mapGetters({
      workShifts: 'getWorkShifts',
      workAreas: 'getWorkAreas'
    })
  },
  watch: {
    selectedTab: function (value) {
      localStorage.setItem('brigadeCardSelectedTab', value)
    },
    employeesIds: function (value) {
      if (this.onlyEditEmployees && (!value || !value.length || !value.includes(this.brigade.brigadierId))) {
        const availableBrigadiers = this.brigadiers.filter(employee => value && value.length && value.includes(employee.id) || false)
        this.brigade.brigadierId = availableBrigadiers.length ? availableBrigadiers[0].id : null
      }
    }
  },
  created: function () {
    this.loading = true

    this.getBrigade()

    if (this.onlyEditEmployees) {
      this.selectedTab = 'generalInfo'
    } else {
      if (this.showNotificationsTab) {
        this.tabs.push('notifications')
      }
      if (this.showActiveRequestsTab) {
        this.tabs.push('activeRequests')
      }
      const savedTab = localStorage.getItem('brigadeCardSelectedTab')
      const selectedTab = this.initialTab || savedTab
      this.selectedTab = selectedTab !== null && this.tabs.includes(selectedTab) ? selectedTab : this.tabs[0]

      this.getRegion()
    }
  },
  methods: {
    getBrigade: function () {
      let date = new Date()

      const today = new Date()
      today.setHours(0, 0, 0, 0)
      if (this.date.getTime() !== today.getTime()) {
        date = this.date
      }

      axiosGet({
        url: 'service/delta/brigade/get?id=' + this.brigadeId + '&date=' + date.getTime(),
        onSuccess: (response) => {
          this.convertBrigadeFromServer(response.data)
          this.brigadeInitial = JSON.parse(JSON.stringify((this.brigade)))
        },
        onFailure: 'Ошибка получения информации по бригаде',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onSelectedWorkAreas: function (workAreasKeys) {
      if (workAreasKeys && workAreasKeys.length) {
        this.brigadeWorkAreas = this.workAreas.filter(workArea => workAreasKeys.includes(workArea.key))
      }
    },
    onSelectedWorkShift: function (workShift) {
      this.$set(this.brigade, 'workShift', workShift)
    },
    onSelectedBrigadier: function (brigadier) {
      this.$set(this.brigade, 'brigadier', brigadier)
      if (brigadier) {
        this.$set(this.brigade, 'brigadierId', brigadier.id)
      } else {
        this.$set(this.brigade, 'brigadierId', null)
      }
    },
    onCloseCreateBrigade: function () {
      this.$emit('close')
    },
    onSaveEditBrigade: function () {
      this.editBrigade()
    },
    editBrigade: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      const brigade = {
        id: this.brigade.id,
        name: this.brigade.name,
        brigadier: this.brigade.brigadierId, // !!!
        employees: this.employeesIds, // !!!
        checkWorkAreas: true // TODO: Fix.
      }

      brigade.workDate = this.date.getTime()
      brigade.workShift = this.brigade.workShift

      this.pushBrigadeListPropertiesToSave(brigade, this.brigade, this.brigadeInitial, [
        'fixedEmployees',
        'workAreas',
        'redirectedWorkAreas', // +
        'region' // +-
      ])
      this.pushBrigadeListPropertiesToSave(brigade, this.brigade, this.brigadeInitial, this.brigadeAutoAssignListProperties) // !!!
      this.pushBrigadeBooleanPropertiesToSave(brigade, this.brigade, this.brigadeInitial, this.brigadeBooleanProperties) // !!!

      const bodyFormData = new FormData()
      bodyFormData.set('data', JSON.stringify([brigade]))

      axiosPost({
        url: 'service/delta/brigade/change',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$emit('update', { brigades: { ids: [this.brigade.id], operation: 'update' }, employees: { ids: getObjectsIds(this.initialEmployees) } })

          if (response.data && response.data.errors && response.data.errors.length) {
            this.$q.notify({
              type: 'negative',
              message: response.data.errors.join(', '),
              progress: true,
              timeout: 8000
            })
          } else {
            this.$q.notify({
              type: 'positive',
              message: 'Изменена бригада "' + this.brigade.name + '"',
              progress: true,
              timeout: 3000
            })
          }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => this.$q.loading.hide())
    },
    getRegion: function () {
      const urlParams = new URLSearchParams()
      urlParams.append('params', JSON.stringify([
        { param: 'showInFilter', type: 'boolean', action: '=', value: true }
      ]))
      axiosGet({
        url: '/service/obj/search?type=Region&limit=1000&' + urlParams.toString(),
        onSuccess: (response) => {
          this.regions = response.data.result
        },
        onFailure: 'Ошибка получения округов',
        msgTarget: this
      })
    },
    convertBrigadeFromServer: function (inputBrigade) {
      this.brigadeFromServer = inputBrigade

      this.brigade = {}
      this.$set(this.brigade, 'id', inputBrigade.id)
      this.$set(this.brigade, 'name', inputBrigade.name)
      this.$set(this.brigade, 'workShift', inputBrigade.workShift.key)
      this.$set(this.brigade, 'workAreas', [])
      this.$set(this.brigade, 'redirectedWorkAreas', [])
      if (inputBrigade.workAreas) {
        inputBrigade.workAreas.forEach(workArea => {
          if (workArea.main) {
            this.brigade.workAreas.push(workArea.id)
          } else {
            this.brigade.redirectedWorkAreas.push(workArea.id)
          }
        })
        this.onSelectedWorkAreas(this.brigade.workAreas)
      }

      if (inputBrigade.activeRequests) {
        this.copyListProperties(this.brigade, inputBrigade, ['activeRequests'])
      }

      if (inputBrigade.queueRequests) {
        this.copyListProperties(this.brigade, inputBrigade, ['queueRequests'])
      }

      // TODO получать бригадира и сотрудников за нужную смену
      const brigadierId = this.brigadierId || inputBrigade.brigadier
      const employees = inputBrigade.employees || []
      this.$set(this.brigade, 'brigadierId', null)
      this.$set(this.brigade, 'brigadier', null)
      employees.forEach(employee => {
        if (employee.id === brigadierId) {
          this.brigade.brigadier = employee
          this.brigade.brigadierId = employee.id
        }
        if (employee.roles && employee.roles.brigadier != null) {
          this.brigadiers.push(employee)
        }
      })

      this.initialEmployees = employees
      this.employeesIds = getObjectsIds(employees)

      this.copyBooleanProperties(this.brigade, inputBrigade, this.brigadeBooleanProperties)

      this.copyListProperties(this.brigade, inputBrigade, this.brigadeAutoAssignListProperties) // !!!
      const brigadeCommonAutoAssignListProperties = this.brigadeCommonAutoAssignListProperties
      Object.defineProperty(this.brigade, 'hasCommonAutoAssignSettings', {
        get: function () {
          for (let i = 0; i < brigadeCommonAutoAssignListProperties.length; i++) {
            const array = this[brigadeCommonAutoAssignListProperties[i]]
            if (array && array.length) {
              return true
            }
          }
          return false
        }
      })
      const brigadeUrgentAutoAssignListProperties = this.brigadeUrgentAutoAssignListProperties
      Object.defineProperty(this.brigade, 'hasUrgentAutoAssignSettings', {
        get: function () {
          for (let i = 0; i < brigadeUrgentAutoAssignListProperties.length; i++) {
            const array = this[brigadeUrgentAutoAssignListProperties[i]]
            if (array && array.length) {
              return true
            }
          }
          return false
        }
      })
      Object.defineProperty(this.brigade, 'hasAutoAssignSettings', {
        get: function () {
          return this.hasCommonAutoAssignSettings || this.hasUrgentAutoAssignSettings
        }
      })

      this.$set(this.brigade, 'region', getObjectsIds(inputBrigade.regions))
      // this.brigade.region = getObjectsIds(inputBrigade.regions)
      // this.brigade.fixedEmployees = getObjectsIds(inputBrigade.fixedEmployees)
      this.$set(this.brigade, 'fixedEmployees', getObjectsIds(inputBrigade.fixedEmployees))
      // Назначенные + фиксированные сотрудники
      this.employeesDataForFixed = JSON.parse(JSON.stringify(employees))
      if (inputBrigade.fixedEmployees) {
        inputBrigade.fixedEmployees.forEach(fixedEmployee => {
          if (!this.employeesIds.includes(fixedEmployee.id)) {
            fixedEmployee.name = fixedEmployee.fio
            this.employeesDataForFixed.push(fixedEmployee)
          }
        })
      }
    }
  }
}

